import { ApiService } from './api.service';
import { CookieService } from './cookie.service';
import { TrackerServiceInstance } from './tracker.service';

import * as interfaces from 'interfaces';

export let AnswerServiceInstance: AnswerService | null = null;

export function createAnswerServiceInstance(): void {
  if (!AnswerServiceInstance) {
    AnswerServiceInstance = new AnswerService();
  }
}

export class AnswerService extends ApiService {
  private id: string;

  constructor() {
    super();

    this.id = 'AnswerService';

    const token = CookieService.getLocalStorage('token') || CookieService.getCookie('token');

    this.updateRequestHeader('Authorization', token);
  }

  getAnswers(clientId: string, userId: string): Promise<interfaces.AnswerInterface[]> {
    const errorIdentifier = `${this.id} -> Get Answers List`;

    return this.get({ endpoint: 'answers', path: `?clientId=${clientId}&userId=${userId}&_=${+new Date()}` })
      .then((res: any) => {
        const responseData: interfaces.GeneralResponseInterface<interfaces.AnswerInterface> = res.data;

        if (!responseData.data || !responseData.data.length)
          this.reportInvalidResponseError(errorIdentifier, res);

        return responseData.data;
      })
      .catch(err => {
        this.reportRequestError(errorIdentifier, err);

        return [] as interfaces.AnswerInterface[];
      });
  }

  likeAnswer(userId: string, answerId: string): Promise<interfaces.LikeInterface> {
    const errorIdentifier = `${this.id} -> Like Answer`;
    const user = CookieService.getLocalStorage('user', true);
    userId = user.id || userId;

    TrackerServiceInstance?.trackEvent('likeVideo', { event_category: 'Answers', userId, answerId });

    return this.post({ endpoint: 'likes' }, { userId, answerId })
      .then((res: any) => {
        const responseData: interfaces.GeneralResponseInterface<interfaces.LikeInterface> = res.data;

        if (!responseData.data || !responseData.data.length)
          this.reportInvalidResponseError(errorIdentifier, res);

        return responseData.data[0] as interfaces.LikeInterface;
      })
      .catch(err => {
        this.reportRequestError(errorIdentifier, err);

        return {} as interfaces.LikeInterface;
      });
  }
}
